import { join } from '../base-service/service';
export default {
    // 提交表单
    insertApply(data = {}) {
        return join('/insertApply.do', data);
    },
};
